/* globals document, window */
import React from "react";
import { hydrate } from "react-dom";
import Login from "./Login";

/* Render Login app into the pug template, pulling props from global window */
function render(props) {
  hydrate(<Login {...props} />, document.getElementById("react"));
}
render(window.reactProps);
